import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { Route, RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared';
import { FullCalendarModule } from '@fullcalendar/angular';
import { TranslateModule } from '@ngx-translate/core';
import { NgxsModule } from '@ngxs/store';
import { OnboardingChecklistModule } from '@radioking/onboarding-checklist';
import { MobileCalendarHeaderComponent } from 'libs/ui/mobile-calendar-header/mobile-calendar-header.component';

import { ProgramsState } from '@radioking/programs';
import { SchedulerCoreModule } from '@radioking/scheduler-core';
import { CanDeactivatePanelGuard } from '@radioking/shared/pannel-manager';
import { UiButtonModule } from '@radioking/ui/button';
import { UiDatepickerModule } from '@radioking/ui/datepicker';
import { UiInputModule } from '@radioking/ui/input';
import { UiPageTitleModule } from '@radioking/ui/page-title';
import { UiPlaylistIconModule } from '@radioking/ui/playlist-icon';
import { UiQuestionMarkModule } from '@radioking/ui/question-mark';
import { UiTooltipModule } from '@radioking/ui/tooltip';
import { UiTrackInputWithSuggestionsModule } from '@radioking/ui/track-input-with-suggestions';
import { UiWeekdaySelectModule } from '@radioking/ui/weekday-select';
import { SchedulerCoreState } from '../../../scheduler-core/src/lib/states/scheduler-core.state';
import { PipesModule } from '../../../shared/pipes/pipes.module';

import { MatStepperModule } from '@angular/material/stepper';
import { UiMobileCloseButtonModule } from '@radioking/ui/mobile-close-button';
import { UiMobileFabButtonModule } from '@radioking/ui/mobile-fab-button';
import { PlanningDayHeaderComponent } from './components/planning-day-header/planning-day-header.component';
import { PlanningHeaderComponent } from './components/planning-header/planning-header.component';
import { PlanningShellComponent } from './components/planning-shell/planning-shell.component';
import { PlanningSlotAddComponent } from './components/planning-slot-add/planning-slot-add.component';
import { PlanningSlotDeletionComponent } from './components/planning-slot-deletion/planning-slot-deletion.component';
import { PlanningSlotEditionComponent } from './components/planning-slot-edition/planning-slot-edition.component';
import { PlanningSlotMoveComponent } from './components/planning-slot-move/planning-slot-move.component';
import { PlanningSlotPopoverComponent } from './components/planning-slot-popover/planning-slot-popover.component';
import { PlanningState } from './states/planning.state';

const routes: Route[] = [
  {
    path: 'planning',
    component: PlanningShellComponent,
    canDeactivate: [CanDeactivatePanelGuard],
  },
];

@NgModule({
  imports: [
    // Angular core modules
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),

    // Angular Material modules
    MatButtonToggleModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatStepperModule,

    // CDK and scrolling
    ScrollingModule,

    // Third-party modules
    FullCalendarModule,
    TranslateModule,

    // State management
    NgxsModule.forFeature([PlanningState, SchedulerCoreState, ProgramsState]),

    // Shared and custom modules
    SharedModule,
    PipesModule,
    SchedulerCoreModule,
    OnboardingChecklistModule,

    // UI modules
    UiButtonModule,
    UiDatepickerModule,
    UiInputModule,
    UiMobileCloseButtonModule,
    UiMobileFabButtonModule,
    UiPageTitleModule,
    UiPlaylistIconModule,
    UiQuestionMarkModule,
    UiTooltipModule,
    UiTrackInputWithSuggestionsModule,
    UiWeekdaySelectModule,

    // Custom components
    MobileCalendarHeaderComponent,
  ],
  declarations: [
    PlanningShellComponent,
    PlanningHeaderComponent,
    PlanningSlotPopoverComponent,
    PlanningSlotEditionComponent,
    PlanningSlotDeletionComponent,
    PlanningSlotMoveComponent,
    PlanningDayHeaderComponent,
    PlanningSlotAddComponent,
  ],
})
export class PlanningModule {}
